// extracted by mini-css-extract-plugin
module.exports = {"button":"SettingsSubscriptionButton_button__y88x_"};